import { render } from "./SelectProfile.vue?vue&type=template&id=65df842c&ts=true"
import script from "./SelectProfile.ts?vue&type=script&lang=ts&external"
export * from "./SelectProfile.ts?vue&type=script&lang=ts&external"

import "./SelectProfile.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__